<template>
  <div>
    <v-btn :small="small" :light="light" type="button" v-on:click="onexport">
      <v-icon :small="small" class="mr-2"> mdi-microsoft-excel</v-icon>Excel
    </v-btn>
  </div>
</template>

<script>
import constants from '@/data/constants'
import XLSX from 'xlsx'
export default {
  props: {
    data: Array,
    name: String,
    fileName: String,
    light: Boolean,
    small: Boolean,
    columns: Array,
  },
  data: () => ({
    constants: constants,
  }),
  // async created () {
  //   this.Datas = await api.getDatas()
  // },
  methods: {
    getVisaStatus(vs) {
      var out = constants.VISA_STATUSES.find((s) => s.id == vs)
      if (out) {
        return out.name
      } else {
        return 'Visa status unknown'
      }
    },
    format_date(date) {
      // console.log(date)
      var moment = require('moment')
      var ndate = new Date(date)
      // console.log(moment(ndate).format('YYYY-MM-DD'))
      return moment(ndate).format('YYYY-MM-DD')
    },
    onexport() {
      // console.log(this.data[0])
      // var animalWS = XLSX.utils.json_to_sheet(this.Datas.animals)
      if (this.columns) {
        var col = [
          'id',
          'title',
          'subtitle',
          'full_name',
          'accession_number',
          'production_date_new',
        ].concat(this.columns.map((c) => c.id))
        // , 'last_media_check'
        this.col =
          col.concat[
            ('acquisition_date',
            'acquisition_method_text',
            'acquisition_source_text',
            'name',
            'classification',
            'credit',
            'edition_state',
            'exhibitions',
            'media_material_description',
            'todos',
            'last_media_check',
            'visa_status_text')
          ]
      } else {
        var col = [
          'id',
          'title',
          'subtitle',
          'full_name',
          'accession_number',
          'production_date_new',
          'acquisition_date',
          'acquisition_method_text',
          'acquisition_source_text',
          'name',
          'classification',
          'credit',
          'edition_state',
          'exhibitions',
          'media_material_description',
          'todos',
          'visa_status_text',
        ]
      }
      var settings = {
        // skipHeader: true,
        origin: 'A2',
      }
      let transformedData = []
      this.data.forEach((textRow) => {
        var out = {}
        if (col.includes('todos')) {
          var todos = Object.assign(
            [],
            this.$store.state.todos.filter((t) => {
              return textRow.id == t.artwork_id && t.done != 1
            })
          )
          todos = todos.map((a) => {
            return a.title
          })
        }

        if (col.includes('packings')) {
          var packings = Object.assign(
            [],
            this.$store.state.packings.filter((t) => {
              return textRow.id == t.artwork_id
            })
          )
          // var packings_text = packings.map(a => {return a.colli})
        }

        if (col.includes('exhibitions')) {
          var exhibitions = Object.assign(
            [],
            this.$store.state.exhibitions.filter((t) => {
              return t.artworks.map((a) => (a = a.id)).includes(textRow.id)
            })
          )
          // var exhibitions_text = exhibitions.map(a => { return a.title + ' (' + a.duration_start + '–' + a.duration_end + ') ' + a.institution})
        }
        // console.log(exhibitions)
        // , 'conservator', 'last_media_check'
        var all_fields = [
          'id',
          'title',
          'paid_in_country',
          'acquisition_source_text',
          'import_export_notes',
          'import_date',
          'import_export_history',
          'subtitle',
          'full_name',
          'top_photo_id',
          'accession_number',
          'production_date_new',
          'acquisition_date',
          'acquisition_method_text',
          'visa_status_text',
          'ownership_info',
          'edition_state',
          'certificate_new',
          'media_material_description',
          'location_name',
          'location_notes',
          'deaccessioned',
          'credit',
          'purchase_price',
          'purchase_price_currency',
          'insurance_value',
          'insurance_value_currency',
          'signature_new',
          'dim',
          'dim_details',
          'todos',
          'exhibitions',
          'packings',
          'technician',
          'space_max_min',
          'required_equipment',
          'tools_and_gear',
          'light',
          'climate_and_conditions',
          'power',
          'spare_or_replacement_parts',
          'display_notes_and_other_special_merged',
          'projection',
          'sound_and_acoustic',
          'on_off_procedure',
          'maintenance',
          'security_and_safety_details',
          'regular_inspection',
          'cleaning_artwork',
          'contacts_producers',
          'hanging_devices',
          'specifications_on_space',
          'last_media_check',
        ]
        // , 'conservator', 'last_media_check'
        var unformatted_fields = [
          'id',
          'title',
          'last_media_check',
          'paid_in_country',
          'import_export_notes',
          'import_date',
          'import_export_history',
          'import_taxes',
          'subtitle',
          'full_name',
          'top_photo_id',
          'accession_number',
          'production_date_new',
          'acquisition_date',
          'acquisition_method_text',
          'edition_state',
          'media_material_description',
          'location_notes',
          'credit',
          'purchase_price',
          'purchase_price_currency',
          'insurance_value',
          'insurance_value_currency',
          'technician',
          'space_max_min',
          'required_equipment',
          'tools_and_gear',
          'light',
          'climate_and_conditions',
          'power',
          'spare_or_replacement_parts',
          'display_notes_and_other_special_merged',
          'projection',
          'sound_and_acoustic',
          'on_off_procedure',
          'maintenance',
          'security_and_safety_details',
          'regular_inspection',
          'cleaning_artwork',
          'contacts_producers',
          'hanging_devices',
          'specifications_on_space',
        ]
        // console.log(col);
        col.forEach((f) => {
          if (unformatted_fields.includes(f)) {
            out[f] = textRow[f] ? textRow[f] : ''
          } else {
            // nacitam text acq source
            var c = this.$store.state.contacts.find(
              (as) => as.id === textRow.acquisition_source_id
            )
            if (c) {
              var as = c.name
            } else {
              var as = 'Not set'
            }

            if (f === 'dim') {
              out[f] = textRow.dim_f_json ? textRow.dim_f_json : ''
            } else if (f === 'dim_detail') {
              out['Height (cm)'] = textRow.dim_height
              out['Width (cm)'] = textRow.dim_width
              out['Depth (cm)'] = textRow.dim_depth
              // if (textRow.dim_depth & textRow.dim_height & textRow.dim_width) {
              console.log(textRow.dim_height)
              console.log(textRow.dim_width)
              console.log(textRow.dim_depth)
              console.log(
                textRow.dim_depth * textRow.dim_height * textRow.dim_width
              )
              var x = (
                (textRow.dim_depth * textRow.dim_height * textRow.dim_width) /
                1000000
              ).toString()
              console.log('xxxxxx')
              console.log(x)
              console.log('xxxxxx')
              out['Space (m3)'] = x
              // } else {
              //   out['Space (m3)'] = ''
              // }
              if (textRow.dim_depth & textRow.dim_width) {
                out['Footprint (m2)'] =
                  (textRow.dim_depth * textRow.dim_width) / 10000
              } else {
                out['Footprint (m2)'] = ''
              }
              out['Frame Height (cm)'] = textRow.dim_frame_height
              out['Frame Width (cm)'] = textRow.dim_frame_width
              out['Frame Depth (cm)'] = textRow.dim_frame_depth
              if (
                textRow.dim_frame_height &
                textRow.dim_frame_width &
                textRow.dim_frame_depth
              ) {
                out['Frame Space (m3)'] =
                  (textRow.dim_frame_height *
                    textRow.dim_frame_width *
                    textRow.dim_frame_depth) /
                  1000000
              } else {
                out['Frame Space (m3)'] = ''
              }
              if (textRow.dim_frame_width & textRow.dim_frame_depth) {
                out['Frame Footprint (m2)'] =
                  (textRow.dim_frame_width * textRow.dim_frame_depth) / 10000
              } else {
                out['Frame Footprint (m2)'] = ''
              }
              out['Diameter'] = textRow.diameter

              // out[f] = getDimensionDetail(textRow)
            } else if (f === 'location_name') {
              out[f] = this.get_location_name(textRow.artwork_location_id)
            } else if (f === 'classification') {
              out[f] = textRow.classification
                ? textRow.classification.toUpperCase()
                : ''
            } else if (f === 'type_of_work_id') {
              out[f] = textRow.type_of_work_id
                ? constants.TYPES_OF_WORK.find(
                    (t) => t.id == textRow.type_of_work_id
                  ).name
                : ''
            } else if (f === 'ownership_info') {
              // console.log(textRow.ownership)
              if (!textRow.ownership) {
                out[f] = 'NOT SET'
              } else {
                const a = constants.OWNERSHIPS.find(
                  (o) => o.id == textRow.ownership
                )
                out[f] = a ? a.name : 'NOT FOUND'
              }
            } else if (f === 'visa_status_text') {
              out[f] = this.getVisaStatus(textRow.visa_status)
            } else if (f === 'acquisition_source_text') {
              out[f] = this.get_contact(textRow.acquisition_source_id)
            } else if (f === 'insurance_value_text') {
              out['insurance_value'] = textRow.insurance_value
              out['insurance_value_currency'] = textRow.insurance_value_currency
            } else if (f === 'insurance_value_latest') {
              out['insurance_value_latest'] = this.getLatestInsuranceValue(textRow.id)
              out['insurance_value_latest_currency'] = this.getLatestInsuranceCurrency(textRow.id)
            } else if (f === 'purchase_price_text') {
              out['purchase_price'] = textRow.purchased_price
              out['purchase_price_currency'] = textRow.purchased_price_currency
            } else if (f === 'acquisition_date') {
              out[f] = textRow.acquisition_date
                ? this.format_date(textRow.acquisition_date)
                : ''
            } else if (f === 'certificate_new') {
              out[f] = textRow.certificate_new == 1 ? 'Yes' : 'No'
            } else if (f === 'deaccessioned') {
              out[f] = textRow.deaccessioned == 1 ? 'Yes' : 'No'
            } else if (f === 'signature_new') {
              out[f] = textRow.signature_new == 1 ? 'Yes' : 'No'
            } else if (f === 'todos') {
              out[f] = todos.length > 0 ? 'ToDos: ' + todos.join(', ') : ''
              // } else if ( f === 'exhibitions') {
              //   out[f] = exhibitions.length > 0 ? ('Exhibitions: \n >> ' + (exhibitions_text.join('\n >> '))) : ''
              // } else if ( f === 'packings') {
              //   out[f] = packings.length > 0 ? (packings_text) : ''
            }
          }
        })

        // function getDimensionDetail(p) {
        //   if (p) {
        //     //  console.log(packings);
        //     var o = {}
        //     transformedData.push(o)

        //     o['Height (cm)'] = p.dim_height
        //     o['Width (cm)'] = p.dim_width
        //     o['Depth (cm)'] = p.dim_depth
        //     if (p.dim_depth & p.dim_height & p.dim_width) {
        //       o['Space (m3)'] =
        //         (p.dim_depth * p.dim_height * p.dim_width) / 1000000
        //     } else {
        //       o['Space (m3)'] = ''
        //     }
        //     if (p.dim_depth & p.dim_width) {
        //       o['Footprint (m2)'] = (p.dim_depth * p.dim_width) / 10000
        //     } else {
        //       o['Footprint (m2)'] = ''
        //     }
        //     o['Frame Height (cm)'] = p.dim_frame_height
        //     o['Frame Width (cm)'] = p.dim_frame_width
        //     o['Frame Depth (cm)'] = p.dim_frame_depth
        //     if (p.dim_frame_height & p.dim_frame_width & p.dim_frame_depth) {
        //       o['Frame Space (m3)'] =
        //         (p.dim_frame_height * p.dim_frame_width * p.dim_frame_depth) /
        //         1000000
        //     } else {
        //       o['Frame Space (m3)'] = ''
        //     }
        //     if (p.dim_frame_width & p.dim_frame_depth) {
        //       o['Frame Footprint (m2)'] =
        //         (p.dim_frame_width * p.dim_frame_depth) / 10000
        //     } else {
        //       o['Frame Footprint (m2)'] = ''
        //     }
        //     o['Diameter'] = p.diameter
        //     transformedData.push(o)
        //     o = {}
        //   }
        // }

        function getLocation(p, store) {
          var out = 'No Location Set'
          if (p.artwork_location_id > 0) {
            var loc = store.state.locations.find(
              (l) => l.id == p.artwork_location_id
            )
            if (loc) {
              out = loc.name
            } else {
              out = ''
            }
          } else {
            if (textRow['artwork_location_id'] > 0) {
              var loc = store.state.locations.find(
                (l) => l.id == textRow['artwork_location_id']
              )
              if (loc) {
                out = loc.name
              } else {
                out = ''
              }
              out = `Artwork Location: ${out}`
            }
          }
          return out
        }

        transformedData.push(out)

        if (packings) {
          //  console.log(packings);
          var o = {}
          packings.forEach((p) => {
            o['Colli'] = p.colli
            o['Packing'] = p.packing
            o['Length'] = p['lenght']
            o['Width'] = p.width
            o['Height'] = p.height
            o['Weight'] = p.weight
            o['Contents'] = p.contents
            o['Visa Status'] = this.getVisaStatus(p.visa_status)
            o['Packing Location'] = getLocation(p, this.$store)
            transformedData.push(o)
            o = {}
          })
        }

        if (exhibitions) {
          //  console.log(packings);
          var o = {}
          exhibitions.forEach((p) => {
            o['Exhibition Title'] = p.title
            o['Duration'] = p['duration_start'] + '–' + p['duration_end']
            o['Institution'] = p.institution
            transformedData.push(o)
            o = {}
          })
        }
      })
      // {
      // "id": (textRow.id),
      // "full_name": (textRow.full_name),
      // "top_photo_id": textRow.top_photo_id,
      // "acquisition_method_text": textRow.acquisition_method_text,
      // "visa_status_text": textRow.visa_status_text,
      // "ownership_info": textRow.ownership_info,
      // "edition_state": textRow.edition_state,
      // "media_material_description": textRow.media_material_description,
      // "location_name": textRow.location_name,
      // "location_notes": textRow.location_notes,
      // "credit": textRow.credit,
      // "purchase_price_text": textRow.purchase_price + ' ' + textRow.purchase_price_currency,
      // "purchase_price": textRow.purchased_price,
      // "purchase_price_currency": textRow.purchased_price_currency,
      // "insurance_value_text": textRow.insurance_value + ' ' + textRow.insurance_value_currency,
      // "insurance_value": textRow.insurance_value,
      // "insurance_value_currency": textRow.insurance_value_currency,
      // "title": textRow.title,
      //  +', ' + (textRow.production_date_new ? textRow.production_date_new : ''),
      // "accession_number": (textRow.accession_number ? textRow.accession_number : ''),
      // "production_date_new": (textRow.production_date_new ? textRow.production_date_new : ''),
      // "conservator": `${textRow.conservator}`,
      // "last_media_check": `${textRow.last_media_check}`,
      // "classification": (textRow.classification ? textRow.classification.toUpperCase() : ''),
      // "acquisition_date": this.format_date(textRow.acquisition_date),
      // "certificate_new": 'Certificate: ' + (textRow.certificate_new == 1 ? 'Yes' : 'No'),
      // "deaccessioned": ('Deaccessioned: ' + (textRow.deaccessioned == 1 ? 'Yes' : 'No')),
      // "signature_new": 'Signature: ' + (textRow.signature_new == 1 ? 'Yes' : 'No'),
      // "todos": todos.length > 0 ? ('ToDos: ' + (todos.join(', '))) : '',
      // "exhibitions": exhibitions.length > 0 ? ('Exhibitions: \n >> ' + (exhibitions.join('\n >> '))) : '',
      // "packings": packings.length > 0 ? (packings) : ''
      //   }
      // })
      // console.log(dd)
      // console.log(this.data)
      // console.log(col)
      // console.log(transformedData)
      var sheet = XLSX.utils.json_to_sheet(transformedData, settings)
      // var sheet = XLSX.utils.json_to_sheet(this.data)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, animalWS, 'animals')
      // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, sheet, this.name)

      // export Excel file
      XLSX.writeFile(wb, this.fileName + '.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/artworks/Excel.vue